import { Tooltip, Typography } from "antd";
import CypressTestIds from "../../../cypress/CypressTestIds";
import DataTable from "../DataTable";

const { Link } = Typography;

interface IAdminConsoleTenantListProps {
    items: ITenant[];
    onTenantClick: (id: string) => void;
}

const AdminConsoleTenantList = ({ items = [], onTenantClick }: IAdminConsoleTenantListProps) => {
    return (
        <DataTable<ITenant>
            dataTestId={CypressTestIds.ADMIN_CONSOLE_TENANT_LIST}
            hideSelectionColumn
            tableProps={{
                size: "small",
                tableLayout: "auto",
                sticky: true,
                dataSource: items,
                rowKey: "tenantId",
                columns: [
                    {
                        width: "15%",
                        dataIndex: "name",
                        title: "Tenant",
                        ellipsis: { showTitle: false },
                        render: (value, item, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                <Link style={{ color: "#1890ff" }} onClick={() => onTenantClick(item.tenantId)}>
                                    {value}
                                </Link>
                            </Tooltip>
                        ),
                    },
                    {
                        width: "15%",
                        dataIndex: "tenantId",
                        title: "Tenant ID",
                        ellipsis: { showTitle: false },
                        render: (value, item, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "15%",
                        dataIndex: "domain",
                        title: "Tenant Domain",
                        ellipsis: { showTitle: false },
                        render: (value, item, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "10%",
                        dataIndex: "renewalDate",
                        title: "Renewal Date",
                        ellipsis: { showTitle: false },
                        render: (value, item, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value ?? <span className="rounded-md bg-gray-100 px-3 py-1 text-xs text-gray-500">No date</span>}
                            </Tooltip>
                        ),
                    },
                    {
                        width: 100,
                        dataIndex: "activeUserCount",
                        title: "Users",
                        ellipsis: { showTitle: false },
                    },
                    {
                        width: 150,
                        dataIndex: "activeBusinessAreaCount",
                        title: "Business Areas",
                        ellipsis: { showTitle: false },
                    },
                    {
                        width: 100,
                        dataIndex: "activeSchemaCount",
                        title: "Schemas",
                        ellipsis: { showTitle: false },
                    },
                    {
                        width: 100,
                        dataIndex: "activeDataSetCount",
                        title: "Data Sets",
                        ellipsis: { showTitle: false },
                    },
                    {
                        width: 190,
                        dataIndex: "activeDataSetRecordCount",
                        title: "Customer Records",
                        ellipsis: { showTitle: false },
                    },
                ],
            }}
        />
    );
};

export default AdminConsoleTenantList;
